// extracted by mini-css-extract-plugin
export default {"check":"CheckListItem_check__FIwxG"};